import {StockItemUpdateFieldValue} from '../../../shared-utilities/models-old/datastructures';

export interface IAutoOrderDisableItemOutcome extends Object {
  code: string;
  enable: boolean;
  fieldUpdates?: Record<string, StockItemUpdateFieldValue>;
}
